import { forwardRef, type Ref, type SVGProps } from "react";
const IconLongPressFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m23.59 14.47-6.13-.78V8.53a3.46 3.46 0 1 0-6.91 0v10.72c-1-.45-1.79-.82-1.94-.88a3.45 3.45 0 0 0-3.92 1.19A3.4 3.4 0 0 0 4 22.12a3.45 3.45 0 0 0 1.38 2.28l6.55 4.91A3.46 3.46 0 0 0 14 30h9.57a2.64 2.64 0 0 0 2.62-2.31l1.06-8.45a4.3 4.3 0 0 0-3.66-4.77"
    />
    <path
      fill="currentColor"
      d="M8.6 12a.9.9 0 0 0 .4-.08 1 1 0 0 0 .54-1.3 4.79 4.79 0 1 1 8.85 0 1 1 0 1 0 1.84.76 6.7 6.7 0 0 0 .52-2.59 6.79 6.79 0 1 0-13.08 2.59 1 1 0 0 0 .93.62"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLongPressFilledSVG);
ForwardRef.displayName = "IconLongPressFilled";
export { ForwardRef as IconLongPressFilled };
